import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { Observable } from 'rxjs';
import { selectSessionLocale } from './auth/store/session/session.selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  locale: string;
  fixedLocale: string;
  date = new Date();
  uiLocale$: Observable<string>;

  constructor(private translateService: TranslateService, private store: Store, private dateAdapter: DateAdapter<any>) {
    this.translateService.use('sv-SE');
    // Info: for usage in Angular pipes: (uiLocale$ | async)
    this.uiLocale$ = this.store.select(selectSessionLocale);
    // Set locale for dateAdapter, used by datepickers in the application
    this.uiLocale$.subscribe(locale => {
      this.dateAdapter.setLocale(locale);
    });
  }
}
